import { formatCurrency } from '../../utils/format-currency'

interface OrderSummaryFooterProps {
  subtotal: number
  total: number
  discount?: number
  tax?: number
  tip?: number
  className?: string
}

export function OrderSummaryFooter({
  subtotal,
  total,
  discount,
  tax,
  tip,
  className = '',
}: OrderSummaryFooterProps) {
  return (
    <div className={`border-t border-divider pt-3 space-y-2 text-sm ${className}`}>
      <div className="flex items-center justify-between text-muted">
        <span>Subtotal</span>
        <span>{formatCurrency(subtotal)}</span>
      </div>
      {typeof discount === 'number' && discount !== 0 && (
        <div className="flex items-center justify-between text-muted">
          <span>Descuento</span>
          <span>-{formatCurrency(Math.abs(discount))}</span>
        </div>
      )}
      {typeof tax === 'number' && tax !== 0 && (
        <div className="flex items-center justify-between text-muted">
          <span>Impuestos</span>
          <span>{formatCurrency(tax)}</span>
        </div>
      )}
      {typeof tip === 'number' && tip !== 0 && (
        <div className="flex items-center justify-between text-muted">
          <span>Propina</span>
          <span>{formatCurrency(tip)}</span>
        </div>
      )}
      <div className="flex items-center justify-between text-base font-extrabold text-[color:var(--color-text)] bg-gradient-to-r from-slate-50/75 to-slate-100/50 dark:from-neutral-800/35 dark:to-neutral-900/25 p-3 rounded-xl border border-divider/60 mt-3 shadow-inner">
        <span>Total</span>
        <span className="text-lg text-emerald-600 dark:text-emerald-450 tracking-tight">{formatCurrency(total)}</span>
      </div>
    </div>
  )
}

export default OrderSummaryFooter
